__turbopack_context__.v({
  "centered": "FHXSHa_centered",
  "chevronButton": "FHXSHa_chevronButton",
  "chevronOpen": "FHXSHa_chevronOpen",
  "collapseContent": "FHXSHa_collapseContent",
  "icon": "FHXSHa_icon",
  "inner": "FHXSHa_inner",
  "label": "FHXSHa_label",
  "root": "FHXSHa_root",
  "subDesc": "FHXSHa_subDesc",
  "subRightSection": "FHXSHa_subRightSection",
  "subRoot": "FHXSHa_subRoot",
  "subRootCreateNew": "FHXSHa_subRootCreateNew",
  "subText": "FHXSHa_subText",
  "subTitle": "FHXSHa_subTitle",
  "wrapper": "FHXSHa_wrapper",
});
